import R from 'ramda';
import * as fileUploadActions from './fileUploadActions';
import * as submissionActions from 'submission/submissionActions';

import { validateFileUpload } from './fileUploadValidation';

import {
  completeStep,
  initialStepState,
  setCompleted,
  setErrors,
} from 'common/stepReducerUtil';

const initialFileUploadStepState = {
  loadingInitData: false,
  loadingLocalStorage: false,
  fields: {
    copyrightFileName: '',
    dissertationFileName: '',
  },
};

const initialState = R.merge(initialStepState, initialFileUploadStepState);

const copyrightFileNameLens = R.lensPath(['fields', 'copyrightFileName']);
const setCopyrightFileName = R.set(copyrightFileNameLens);
export const getCopyrightFileName = R.view(copyrightFileNameLens);

const dissertationFileNameLens = R.lensPath(['fields', 'dissertationFileName']);
const setDissertationFileName = R.set(dissertationFileNameLens);
export const getDissertationFileName = R.view(dissertationFileNameLens);

const setCopyrightFile = (file, state) =>
  R.pipe(setCompleted(false), setCopyrightFileName(file ? file.name : ''))(
    state,
  );

const setDissertationFile = (file, state) =>
  R.pipe(setCompleted(false), setDissertationFileName(file ? file.name : ''))(
    state,
  );

const cancelSubmission = R.pipe(
  setCompleted(false),
  setErrors(initialState.errors),
  setCopyrightFileName(initialState.fields.copyrightFileName),
  setDissertationFileName(initialState.fields.dissertationFileName),
);

const submissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case fileUploadActions.COMPLETE_STEP:
    case submissionActions.SUBMIT:
      return completeStep(validateFileUpload, state);

    case fileUploadActions.SET_COPYRIGHT_FILE:
      return setCopyrightFile(action.file, state);

    case fileUploadActions.SET_DISSERTATION_FILE:
      return setDissertationFile(action.file, state);

    case submissionActions.CANCEL_SUBMISSION:
      return cancelSubmission(state);

    default:
      return state;
  }
};

export default submissionReducer;



// WEBPACK FOOTER //
// ./src/file-upload/fileUploadReducer.js